import { render } from "./formApGain.vue?vue&type=template&id=0799aabe&scoped=true"
import script from "./formApGain.vue?vue&type=script&lang=js"
export * from "./formApGain.vue?vue&type=script&lang=js"

import "./formApGain.vue?vue&type=style&index=0&id=0799aabe&scoped=true&lang=css"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0799aabe"]])

export default __exports__